import React from 'react';
import Icon from 'components/lib/icons/icon';

/**
 * @visibleName Image Fill
 */

export default function ImageFillIcon(props) {
  return (
    <Icon viewBox="0 0 16 16" {...props}>
      <path
        clipRule="evenodd"
        d="M0 3C0 1.89543 0.895431 1 2 1H14C15.1046 1 16 1.89543 16 3V13C16 14.1046 15.1046 15 14 15H2C0.895431 15 0 14.1046 0 13V3ZM6 5.5C6 6.32843 5.32843 7 4.5 7C3.67157 7 3 6.32843 3 5.5C3 4.67157 3.67157 4 4.5 4C5.32843 4 6 4.67157 6 5.5ZM2.14645 10.8536L3.74517 9.25483C3.89735 9.10265 4.12984 9.06492 4.32233 9.16117L5.67767 9.83883C5.87016 9.93508 6.10265 9.89735 6.25483 9.74517L9.69337 6.30663C9.86931 6.13069 10.1479 6.11089 10.3469 6.26019L13.8 8.85C13.9259 8.94443 14 9.09262 14 9.25V12.5C14 12.7761 13.7761 13 13.5 13H2.5C2.22386 13 2 12.7761 2 12.5V11.2071C2 11.0745 2.05268 10.9473 2.14645 10.8536Z"
        fillRule="evenodd"
      />
    </Icon>
  );
}
